import { memo } from 'react';
import Day from './Day';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function MonthGrid({ monthString, calendarData, userId = 'default', calendarId = null }) {
  // parse "YYYY-MM" into year and 0-indexed month
  const [year, monthNum] = monthString.split('-').map(Number);
  const month = monthNum - 1;

  // day-of-week of the 1st (0=Sun), total days in month
  const first = new Date(year, month, 1).getDay();
  const days = new Date(year, month + 1, 0).getDate();

  // build cell array: nulls for offset, then day numbers 1..days
  const cells = Array(first).fill(null);
  for (let d = 1; d <= days; d++) cells.push(d);

  // convert day number to "YYYY-MM-DD" date string key for Redux lookups
  const iso = (d) => `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

  return (
    // data-month attribute used by IntersectionObserver to track visible month
    <div className="monthBox px-2" data-month={monthString}>
      {/* month + year header */}
      <h3 className="py-3 text-center text-sm font-semibold">
        {new Date(year, month).toLocaleString('default', { month: 'long', year: 'numeric' })}
      </h3>
      {/* weekday labels */}
      <div className="grid grid-cols-7 text-center text-[10px] font-medium uppercase text-muted-foreground px-2">
        {DAYS.map((d) => <div key={d} className="py-1">{d}</div>)}
      </div>
      {/* day grid: empty cells for offset, Day components for real days */}
      <div className="grid grid-cols-7 gap-1 px-2">
        {cells.map((d, i) => {
          if (!d) return <div key={i} className="aspect-square" />;
          return <Day key={i} dateStr={iso(d)} dayNum={d} calendarData={calendarData} userId={userId} calendarId={calendarId} />;
        })}
      </div>
    </div>
  );
}

// memo prevents re-render when parent scrolls but this month's data hasn't changed
export default memo(MonthGrid);
